export enum ESignUpResponseStatus {
  NO_ERROR = 0,
  INVALID_PARAMETER = 400,
  UNAVAILABLE_PARAMETER = 409,
  SERVER_ERROR = 500,
}
